import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ProfileMenu from '../components/common/ProfileMenu';

const AppHeader: React.FC = () => {
  const location = useLocation();

  // Don't show header on landing page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <header className="bg-white border-b border-[#F0F0F0] sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex justify-between items-center">
        {/* Logo */}
        <Link to="/dashboard" className="flex items-center justify-center h-full hover:opacity-80 transition-opacity">
          <img
            src="/focuzon.png"
            alt="Focuzon Logo"
            className="h-8 w-auto object-contain"
            style={{ maxWidth: '140px', minWidth: '100px' }}
          />
        </Link>

        {/* Profile Menu */}
        <ProfileMenu />
      </div>
    </header>
  );
};

export default AppHeader;
